import api from './api';
import { Client } from '../types/client';

class ClientService {
    async getClients(): Promise<Client[]> {
        const response = await api.get('/api/clients');
        return response.data;
    }

    async getClient(id: number): Promise<Client> {
        const response = await api.get(`/api/clients/${id}`);
        return response.data;
    }

    async createClient(client: Omit<Client, 'id'>): Promise<Client> {
        const response = await api.post('/api/clients', client);
        return response.data;
    }

    async updateClient(id: number, client: Client): Promise<Client> {
        const response = await api.put(`/api/clients/${id}`, client);
        return response.data;
    }

    async deleteClient(id: number): Promise<void> {
        await api.delete(`/api/clients/${id}`);
    }
}

export const clientService = new ClientService(); 